import { useEffect, useState } from 'react'
import { jsonrpc } from '~/shared/api/jsonrpc'
import { Box, Header } from '~/shared/ui'
import { CALENDAR, PeriodFigures } from '~/team_tools/dashboard/statistic/figures'
import { formatCount, usePeopleSeries } from './people_series'

/** Signups that came through a referral link, per period and charted by day.
 *  Link visits are one running counter per link with no dates behind them, so
 *  they are a total under the All time figure rather than a period of their
 *  own. */
export const AccountsReferrals = () => {
    const { counts, history } = usePeopleSeries('referral_signups')
    const [visits, setVisits] = useState<number>()

    useEffect(() => {
        jsonrpc('statistic.accounts.referrals').then((res) => {
            const [v] = res.result || []
            setVisits(v)
        })
    }, [])

    return (
        <Box className='w-full text-center'>
            <Header>Referrals</Header>
            <PeriodFigures
                periods={CALENDAR}
                loading={counts.total === undefined}
                value={(period) => formatCount(counts[period])}
                note={() => 'signups'}
                total={{
                    label: 'All time',
                    value: formatCount(counts.total),
                    note: visits !== undefined ? `${formatCount(visits)} link visits` : undefined,
                }}
                chart={{ lines: [{ label: 'Signups', colour: '#eab308', history }] }}
            />
        </Box>
    )
}
